import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// English
import enCommon from "./locales/en/common.json";
// Help pages
import enHelp from "./locales/en/help.json";
import hiHelp from "./locales/hi/help.json";
// Receivables Engine pages (one namespace per area)
import enRcvCommon from "./locales/en/rcvCommon.json";
import enRcvList from "./locales/en/rcvList.json";
import enRcvDetail from "./locales/en/rcvDetail.json";
import enRcvDialogs from "./locales/en/rcvDialogs.json";
import enRcvCreate from "./locales/en/rcvCreate.json";
import enRcvDashboard from "./locales/en/rcvDashboard.json";
import hiRcvCommon from "./locales/hi/rcvCommon.json";
import hiRcvList from "./locales/hi/rcvList.json";
import hiRcvDetail from "./locales/hi/rcvDetail.json";
import hiRcvDialogs from "./locales/hi/rcvDialogs.json";
import hiRcvCreate from "./locales/hi/rcvCreate.json";
import hiRcvDashboard from "./locales/hi/rcvDashboard.json";
import enNavigation from "./locales/en/navigation.json";
import enAppStatus from "./locales/en/appStatus.json";
import enDashboard from "./locales/en/dashboard.json";
import enTopbar from "./locales/en/topbar.json";
import enActivity from "./locales/en/activity.json";
import enStats from "./locales/en/stats.json";
import enCustomers from "./locales/en/customers.json";
import enRoles from "./locales/en/roles.json";
import enStaffs from "./locales/en/staff.json";
import enOrganization from "./locales/en/organization.json";
import enLanding from "./locales/en/landingPage.json";
import enBusinessUnits from "./locales/en/businessUnits.json";
import enDepartments from "./locales/en/departments.json";
import enContracts from "./locales/en/contracts.json";
import enNewContract from "./locales/en/newContract.json";
import enContractTemplates from "./locales/en/contractTemplates.json";
import enAnalyticsDashboard from "./locales/en/analyticsDashboard.json";
import enAuth from "./locales/en/auth.json";
import enParty from "./locales/en/party.json";
import enContractTitle from "./locales/en/contractTitle.json";
import enContractCategories from "./locales/en/contractCategories.json";
import enContractTypes from "./locales/en/contractType.json";
import enClauseTypes from "./locales/en/clauseType.json";
import enJurisdictions from "./locales/en/jurisdiction.json";
import enEntityTypes from "./locales/en/entityType.json";
import enNotifications from "./locales/en/notifications.json";
import enFileGallery from "./locales/en/fileGallery.json";
import enRenewalReminders from "./locales/en/renewalReminders.json";
import enEmailTemplates from "./locales/en/emailTemplate.json";
import enNoticeTemplates from "./locales/en/noticeTemplate.json";
import enReceivables from "./locales/en/receivables.json";
import enLicensing from "./locales/en/licensing.json";
import enObligations from "./locales/en/obligations.json";
import enAi from "./locales/en/ai.json";
import enCalendar from "./locales/en/calendar.json";
import enClauseLibraryPanel from "./locales/en/clauseLibraryPanel.json";
import enClauseLibrary from "./locales/en/clauseLibrary.json";
import enSectionReview from "./locales/en/sectionReview.json";
import enNativeSigning from "./locales/en/nativeSigning.json";
import enBulkUpload from "./locales/en/bulkUpload.json";
import enComments from "./locales/en/comments.json";

// hindi
import hiCommon from "./locales/hi/common.json";
import hiAi from "./locales/hi/ai.json";
import hiNavigation from "./locales/hi/navigation.json";
import hiAppStatus from "./locales/hi/appStatus.json";
import hiDashboard from "./locales/hi/dashboard.json";
import hiTopbar from "./locales/hi/topbar.json";
import hiCharts from "./locales/hi/charts.json";
import hiActivity from "./locales/hi/activity.json";
import hiRoles from "./locales/hi/roles.json";
import hiStats from "./locales/hi/stats.json";
import hiCustomers from "./locales/hi/customers.json";
import hiStaffs from "./locales/hi/staff.json";
import hiOrganization from "./locales/hi/organization.json";
import hiLanding from "./locales/hi/landingPage.json";
import hiBusinessUnits from "./locales/hi/businessUnits.json";
import hiDepartments from "./locales/hi/departments.json";
import hiContracts from "./locales/hi/contracts.json";
import hiNewContract from "./locales/hi/newContract.json";
import hiContractTemplates from "./locales/hi/contractTemplates.json";
import hiAnalyticsDashboard from "./locales/hi/analyticsDashboard.json";
import hiAuth from "./locales/hi/auth.json";
import hiParty from "./locales/hi/party.json";
import hiContractTitle from "./locales/hi/contractTitle.json";
import hiContractCategories from "./locales/hi/contractCategories.json";
import hiContractTypes from "./locales/hi/contractType.json";
import hiClauseTypes from "./locales/hi/clauseType.json";
import hiJurisdictions from "./locales/hi/jurisdiction.json";
import hiEntityTypes from "./locales/hi/entityType.json";
import hiNotifications from "./locales/hi/notifications.json";
import hiFileGallery from "./locales/hi/fileGallery.json";
import hiRenewalReminders from "./locales/hi/renewalReminders.json";
import hiEmailTemplates from "./locales/hi/emailTemplate.json";
import hiNoticeTemplates from "./locales/hi/noticeTemplate.json";
import hiReceivables from "./locales/hi/receivables.json";
import hiLicensing from "./locales/hi/licensing.json";
import hiObligations from "./locales/hi/obligations.json";
import hiCalendar from "./locales/hi/calendar.json";
import hiClauseLibraryPanel from "./locales/hi/clauseLibraryPanel.json";
import hiClauseLibrary from "./locales/hi/clauseLibrary.json";
import hiSectionReview from "./locales/hi/sectionReview.json";
import hiNativeSigning from "./locales/hi/nativeSigning.json";
import hiBulkUpload from "./locales/hi/bulkUpload.json";
import hiComments from "./locales/hi/comments.json";

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    appStatus: enAppStatus,
    dashboard: enDashboard,
    topbar: enTopbar,
    activity: enActivity,
    stats: enStats,
    customers: enCustomers,
    roles: enRoles,
    staffs: enStaffs,
    organization: enOrganization,
    landing: enLanding,
    businessUnits: enBusinessUnits,
    departments: enDepartments,
    contracts: enContracts,
    newContract: enNewContract,
    contractTemplates: enContractTemplates,
    analyticsDashboard: enAnalyticsDashboard,
    auth: enAuth,
    party: enParty,
    contractTitle: enContractTitle,
    contractCategories: enContractCategories,
    contractTypes: enContractTypes,
    clauseTypes: enClauseTypes,
    jurisdictions: enJurisdictions,
    entityTypes: enEntityTypes,
    notifications: enNotifications,
    fileGallery: enFileGallery,
    renewalReminders: enRenewalReminders,
    emailTemplate: enEmailTemplates,
    noticeTemplate: enNoticeTemplates,
    receivables: enReceivables,
    licensing: enLicensing,
    obligations: enObligations,
    ai: enAi,
    calendar: enCalendar,
    clauseLibraryPanel: enClauseLibraryPanel,
    clauseLibrary: enClauseLibrary,
    sectionReview: enSectionReview,
    nativeSigning: enNativeSigning,
    bulkUpload: enBulkUpload,
    comments: enComments,
    help: enHelp,
    rcvCommon: enRcvCommon,
    rcvList: enRcvList,
    rcvDetail: enRcvDetail,
    rcvDialogs: enRcvDialogs,
    rcvCreate: enRcvCreate,
    rcvDashboard: enRcvDashboard,
  },

  hi: {
    common: hiCommon,
    navigation: hiNavigation,
    appStatus: hiAppStatus,
    dashboard: hiDashboard,
    topbar: hiTopbar,
    charts: hiCharts,
    activity: hiActivity,
    stats: hiStats,
    customers: hiCustomers,
    staffs: hiStaffs,
    roles: hiRoles,
    organization: hiOrganization,
    landing: hiLanding,
    businessUnits: hiBusinessUnits,
    departments: hiDepartments,
    contracts: hiContracts,
    newContract: hiNewContract,
    contractTemplates: hiContractTemplates,
    analyticsDashboard: hiAnalyticsDashboard,
    auth: hiAuth,
    party: hiParty,
    contractTitle: hiContractTitle,
    contractCategories: hiContractCategories,
    contractTypes: hiContractTypes,
    clauseTypes: hiClauseTypes,
    jurisdictions: hiJurisdictions,
    entityTypes: hiEntityTypes,
    notifications: hiNotifications,
    fileGallery: hiFileGallery,
    renewalReminders: hiRenewalReminders,
    emailTemplate: hiEmailTemplates,
    noticeTemplate: hiNoticeTemplates,
    receivables: hiReceivables,
    licensing: hiLicensing,
    obligations: hiObligations,
    ai: hiAi,
    calendar: hiCalendar,
    clauseLibraryPanel: hiClauseLibraryPanel,
    clauseLibrary: hiClauseLibrary,
    sectionReview: hiSectionReview,
    nativeSigning: hiNativeSigning,
    bulkUpload: hiBulkUpload,
    comments: hiComments,
    help: hiHelp,
    rcvCommon: hiRcvCommon,
    rcvList: hiRcvList,
    rcvDetail: hiRcvDetail,
    rcvDialogs: hiRcvDialogs,
    rcvCreate: hiRcvCreate,
    rcvDashboard: hiRcvDashboard,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    fallbackLng: "en",

    supportedLngs: ["en", "hi"],

    ns: [
      "common",
      "navigation",
      "appStatus",
      "dashboard",
      "topbar",
      "charts",
      "tasks",
      "activity",
      "stats",
      "roles",
      "staffs",
      "organization",
      "landing",
      "businessUnits",
      "departments",
      "contracts",
      "newContract",
      "contractTemplates",
      "analyticsDashboard",
      "auth",
      "party",
      "contractTitle",
      "contracrtCategories",
      "contractTypes",
      "clauseTypes",
      "jurisdictions",
      "entityTypes",
      "notifications",
      "fileGallery",
      "renewalReminders",
      "emailTemplate",
      "noticeTemplate",
      "receivables",
      "licensing",
      "obligations",
      // Pactline AI
      "ai",
      // My Calendar
      "calendar",
      // Clause Library panel inside the editors
      "clauseLibraryPanel",
      // Library → Clause Templates
      "clauseLibrary",
      // Section-level review inside a contract (isEmeisReview)
      "sectionReview",
      "nativeSigning",
      // Bulk upload of contracts and legacy contracts (isEmeisBulk)
      "bulkUpload",
      // Comments v2 shared thread UI (isEmeisReview)
      "comments",
      // Help pages
      "help",
      // Receivables Engine: shared labels, list, detail page, recovery dialogs, create wizard, dashboard & settings
      "rcvCommon",
      "rcvList",
      "rcvDetail",
      "rcvDialogs",
      "rcvCreate",
      "rcvDashboard",
    ],

    defaultNS: "common",

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],

      caches: ["localStorage"],
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
